// advance-search/operatorMap.ts
import type { FieldType, OperatorValue } from "./types";

export const OPERATOR_MAP: Record<FieldType, OperatorValue[]> = {
  text: [
    "contains",
    "equals",
    "beginsWith",
    "endsWith",
    "notEquals",
    "notBeginsWith",
    "notEndsWith",
    "notContains"
  ],
  number: ["equals", "notEquals", "gt", "gte", "lt", "lte"],
  date: ["on", "after", "before", "between"],
  datetime: ["on", "after", "before", "between"],
  datemonth: ["on", "after", "before", "between"],
  checkbox: ["is", "isNot"],
  dropdown: ["is", "isNot"],
  lookup: ["containsAny", "containsOnly", "containsAll", "notContains"],
  uuid: ["equals", "notEquals", "gt", "gte", "lt", "lte"],
  json: ["equals", "notEquals", "containsAny"]
};
